// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__fkZEl","reference":"styles_reference__4_1hT","buttons":"styles_buttons__ME_lE"};